import {
  adminActions,
  chatActions,
  paymentActions,
  pharmacistActions,
  pharmacyActions,
  pharmacyAdminActions,
  professionalActions,
  userActions,
} from '../actions';
// User Array
const pharmacyAdmin = Object.values(pharmacyAdminActions);
const professionals = Object.values(professionalActions);
const pharmacist = Object.values(pharmacistActions);
const pharmacy = Object.values(pharmacyActions);
const payment = Object.values(paymentActions);
const admin = Object.values(adminActions);
const user = Object.values(userActions);
const chat = Object.values(chatActions);

const actionTrackerList = [
  ...user,
  ...pharmacist,
  ...pharmacy,
  ...admin,
  ...pharmacyAdmin,
  ...chat,
  ...professionals,
  ...payment,
];

export default actionTrackerList;
